export const SET_LOADING = 'SET_LOADING';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_EMBEDDED = 'SET_EMBEDDED';
export const SET_SHOW_HEADER = 'SET_SHOW_HEADER';
export const SET_SHOW_BACKGROUND = 'SET_SHOW_BACKGROUND';
export const SET_DIPLOMA = 'SET_DIPLOMA';
export const CLEAR_DIPLOMA = 'CLEAR_DIPLOMA';
export const SET_HISTORICO_PARCIAL = 'SET_HISTORICO_PARCIAL';
export const CLEAR_HISTORICO_PARCIAL = 'CLEAR_HISTORICO_PARCIAL';